var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-no-data"},[_c('i',{staticClass:"material-icons icon-no-data",staticStyle:{"margin":"0 10px 2px 0"}},[_vm._v("error")]),_c('p',{staticClass:"label-no-data"},[_vm._v(_vm._s(_vm.message ? _vm.message : _vm.$t('bvs.no_data')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }